<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
     <vs-button color="success" type="gradient" v-clipboard:copy="params.value" size="small">Copy Link Line</vs-button>
     
    </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
}
</script>
